module.exports = __webpack_public_path__ + "static/img/mall_tab_icon_7_1.dc7b57a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mall/mall_tab_icon_7_1.png
// module id = Fu8d
// module chunks = 0